import React, { VFC } from 'react';
import { useSiteMetadata } from 'src/hooks';

type Props = { siteTitle: string };

const Component: VFC<Props> = ({ siteTitle }) => (
  <div>Copyright © 2021 {siteTitle} All Rights Reserved.</div>
);

const Container: VFC = () => {
  const { siteTitle = 'ribbit' } = useSiteMetadata();

  return <Component {...{ siteTitle }} />;
};

export default Container;
